'use client'

import type { NavigationFoldoutProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-foldout.types'

import classNames from 'classnames'
import { FocusTrap } from 'focus-trap-react'
import React, { useRef } from 'react'

import { NavigationFoldoutColumn } from '@maestro/commerce-blocks/components/navigation-header'
import { useNavigationFoldout } from '@maestro/commerce-blocks/components/navigation-header/batons/use-navigation-foldout'
import { Mask } from '@pearlconvert/ui/components/mask'

import '@maestro/commerce-blocks/components/navigation-header/styles/navigation-foldout.scss'

export default function NavigationFoldout(props: NavigationFoldoutProps) {
  const { menu } = props
  const {
    columns,
    activeNodeIds,
    closeMenu,
    handleNavigate,
    isExpandable,
    isOpen,
    openColumn,
  } = useNavigationFoldout({ menu })
  const panelRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          clickOutsideDeactivates: true,
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: () => panelRef.current as HTMLElement,
        }}
      >
        <div
          ref={panelRef}
          tabIndex={-1}
          className={classNames('nav-foldout', {
            'nav-foldout--active': isOpen,
          })}
          aria-hidden={!isOpen}
          inert={!isOpen}
        >
          <div className="nav-foldout__body">
            {columns.map((column, index) => (
              <NavigationFoldoutColumn
                key={column.key}
                column={column}
                index={index}
                activeNodeIds={activeNodeIds}
                isExpandable={isExpandable}
                openColumn={openColumn}
                handleNavigate={handleNavigate}
              />
            ))}
          </div>
        </div>
      </FocusTrap>
      <Mask isActive={isOpen} onDismiss={closeMenu} />
    </>
  )
}
